import { Geometry, Polygon } from '@turf/helpers'
import { Feature } from 'src/common-services'
import { BaseClient } from 'src/common-services/clients/base-client'
import {
  AMLocation,
  AMLocationRequest,
  AMLocationScored,
  AMLocationSearchNearestRequest,
  AMLocationSearchPolygonRequest,
  AMMobilityShoppingCenterFromLocation,
  AMShoppingCenterPolygonRequest,
} from 'src/common-services/types/alphamap'

export class LocationsClient extends BaseClient {
  getById(request: AMLocationRequest): Promise<AMLocation> {
    return this.call<AMLocation>(`/v2/locations/${request.id}`, 'GET')
  }
  getSearchNearest(request: AMLocationSearchNearestRequest): Promise<AMLocationScored[]> {
    return this.call<AMLocationScored[]>('/v2/locations/search-nearest', 'POST', {
      data: request,
    })
  }
  getSearchByPolygon(request: AMLocationSearchPolygonRequest): Promise<AMLocation[]> {
    return this.call<AMLocation[]>('/v2/locations/search-polygon', 'POST', {
      data: request,
    })
  }
  getShoppingCenterPolygon(request: AMShoppingCenterPolygonRequest): Promise<Polygon> {
    return this.call<Polygon>(`/v2/locations/shopping-center-polygon/${request.locationId}`, 'GET')
  }

  getShoppingCenterFromLocation(id: string): Promise<AMMobilityShoppingCenterFromLocation> {
    return this.call<AMMobilityShoppingCenterFromLocation>(`/v2/locations/search-shopping-center/${id}`, 'GET')
  }

  getLocationParcel(lat: number, lng: number): Promise<Feature<Geometry, { mCode: string }>> {
    return this.call<Feature<Geometry, { mCode: string }>>(`/v2/locations/parcel?lat=${lat}&lng=${lng}`, 'GET')
  }
}
